import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import type { CurrentEvent } from '../store/events/events_reducers';

/**
 * Generates a URL for the leaderboard page of a specific event.
 *
 * The URL is constructed using the current window origin and the event's slug
 * (if available and non-empty) or falls back to the event's ID.
 *
 * @param event - The event object containing either a slug or ID for URL generation
 * @returns The complete URL string pointing to the event's leaderboard page
 *
 * @example
 * ```typescript
 * const event = { slug: 'summer-race-2024', id: '123' };
 * const url = getLeaderboardUrl(event);
 * // Returns: "https://racemap.com/leaderboard/summer-race-2024"
 * ```
 */
export function getLeaderboardUrl(
  event: Immutable<RacemapEvent | CurrentEvent>,
  { onlyPath } = { onlyPath: false },
): string {
  const base = onlyPath ? '' : `${window.location.origin}`;
  return `${base}/leaderboard/${event.slug != null && event.slug !== '' ? event.slug : event.id}`;
}
